import TopNav from "../../home/components/TopNav";
import GGHero from "./components/GGHero";
import GGFeatures from "./components/GGFeatures";
import GGMonitor from "./components/GGMonitor";
import GGCases from "./components/GGCases";
import GGContact from "./components/GGContact";

export default function GovGridPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />
      <div className="pt-14">
        <GGHero />
        <GGFeatures />
        <GGMonitor />
        <GGCases />
        <GGContact />
      </div>
    </div>
  );
}
